import React from 'react';
import './ui/normalize.css'
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {ThemeProvider} from 'styled-components';
import {BrowserRouter} from 'react-router-dom';
import { theme } from './ui/theme';
import GlobalStyles from './components/ui/GlobalStyles';
import Amplify from "aws-amplify";
import awsExports from "./aws-exports";
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import {Provider} from 'react-redux';
import store from './store'
import {fetchUser} from './features/user/userSlice';

Amplify.configure(awsExports);
const stripePromise = loadStripe('pk_test_51JSrkqKgooPE7vCMeYBJjw38LKsO9Qh0ZFV8esilrVyqtkrcAWSkTtryBK6rHVr7o9wH2okUdhYgjTojzQyLgdsh00oRef3WO9');

store.dispatch(fetchUser())

ReactDOM.render(
  <React.StrictMode>
    <Elements stripe={stripePromise}>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <GlobalStyles/>
          <Provider store={store}>
            <App />
          </Provider>
        </BrowserRouter>
      </ThemeProvider>
    </Elements>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
